import { NavLink, useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { writeAuthReturnLocation } from "../../domain/auth/authReturnLocation";
import TRAIcon from "../icons/TRAIcon";
import { resolveActiveNavId, resolvePlatformNavItems } from "./platformNavItems";
import styles from "./shell.module.css";
import { cn } from "../utils/cn";

/** Tablet side rail for primary destinations. Hidden on mobile and desktop (≥1024). */
export default function NavigationRail({ items, className }) {
  const { pathname } = useLocation();
  const location = useLocation();
  const { isAuthenticated } = useAuth();
  const navItems = items ?? resolvePlatformNavItems(isAuthenticated);
  const activeId = resolveActiveNavId(pathname);

  return (
    <nav className={cn(styles.rail, className)} aria-label="Primary rail">
      {navItems.map((item) => {
        const active = item.id === activeId;
        const signIn = item.to === "/sign-in";
        return (
          <NavLink
            key={item.id}
            to={item.to}
            end={item.to === "/"}
            state={signIn ? { from: location } : undefined}
            className={cn(styles.railLink, active && styles.railLinkActive)}
            aria-current={active ? "page" : undefined}
            aria-label={item.label}
            onClick={
              signIn
                ? () => {
                    writeAuthReturnLocation(location);
                  }
                : undefined
            }
          >
            <TRAIcon name={item.icon} size="md" />
            <span>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
}
